import React, { useEffect , useRef,useState} from "react";
import notecontext from "../context/notes/Notecontext";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import Noteitem from "./Noteitem";
import Addnote from "./Addnote";
export default function Notes() {
    const navigate = useNavigate();

  const context = useContext(notecontext);
  const { notes ,getnotes,editnote} = context;
  useEffect(()=>{
    if(localStorage.getItem("token")){
      getnotes()
    }
    else{
navigate('/login');
    }
  },[ ])
    const [note, setnote] = useState({ id:"",etitle: "", edescription: "", etag: "" });
  const updatenote=(currentnote)=>{
    ref.current.click()
    setnote({id:currentnote._id,etitle:currentnote.title,edescription:currentnote.description,etag:currentnote.tag})
  }
    const handleclick = (e) => {
    refclose.current.click();
    // Call editnote with correct arguments, not as an object
    editnote(note.id, note.etitle, note.edescription, note.etag);
    e.preventDefault();
  };

  const onchange = (e) => {
    setnote({ ...note, [e.target.name]: e.target.value });
  };
  const ref= useRef(null)
  const refclose= useRef(null)
  return (
    <>
      <Addnote/>
  <button type="button" className="btn btn-primary d-none" ref={ref}  data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button>
<div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Note</h1>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
         <form>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title</label>
          <input type="text" className="form-control" name='etitle' id="etitle"  minLength={5} required value={note.etitle} aria-describedby="emailHelp" onChange={onchange} />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description</label>
          <input type="text" className="form-control" id="edescription" name='edescription' minLength={5} required value={note.edescription} onChange={onchange} />
        </div>
        <div className="mb-3">
          <label htmlFor="tag" className="form-label">Tag</label>
          <input type="text" className="form-control" id="etag" name='etag' minLength={5} required value={note.etag} onChange={onchange} />
        </div>
      </form>
      </div>
      <div className="modal-footer">
        <button type="button"ref={refclose} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" disabled={note.etitle.length<5 || note.edescription.length<5} onClick={handleclick} className="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
    <div className="row my-3">
      <h2>Your Notes</h2>
      {notes.map((e) => {
        return <Noteitem key={e._id}e={e} updatenote={updatenote}/>;
      })}
    </div></>
  );
}
